// const Home = () => <div className="p-4">Welcome to the Home Page</div>;
// export default Home;

import React from 'react';
import Jumbotron from './../components/Jumbotron';

const Home = () => {
  return (
    <div className="flex flex-col"> 
      <Jumbotron/>
    </div>
  );
};

export default Home;
